/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/library-controls.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';
import { LibraryControlAuditFields } from '@queries/generated/fragments.generated';

const LibraryControlRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              Phase: oldRecord.Phase === null ? undefined : oldRecord.Phase,
              ReviewFrequencyPeriod: oldRecord.ReviewFrequencyUnits,
              ReviewFrequencyUnits: oldRecord.ReviewFrequencyPeriod,
          }
        : null;

    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              Phase: newRecord.Phase === null ? undefined : newRecord.Phase,
              ReviewFrequencyPeriod: newRecord.ReviewFrequencyUnits === 0 ? undefined : newRecord.ReviewFrequencyUnits,
              ReviewFrequencyUnits: newRecord.ReviewFrequencyPeriod === 0 ? undefined : newRecord.ReviewFrequencyPeriod,
          }
        : null;

    const enums: any = {
        ReviewFrequencyPeriod: AuditEnumValues.TimeFrequency,
        Phase: AuditEnumValues.ControlPhase,
    };

    const lookups: any = {
        ControlTypeId: (libraryControl: LibraryControlAuditFields) => libraryControl?.controlType?.name,
        ResponsibleFunctionId: (libraryControl: LibraryControlAuditFields) => libraryControl?.responsibleFunction?.name,
        ControlPhaseId: (libraryControl: LibraryControlAuditFields) => libraryControl?.controlPhase?.name,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
            lookups,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { LibraryControlRecordChangeGrid };
